/*
  Hidden labels the markup cannot carry itself. (DTC-146, DTC-147)

  New-tab links (WCAG 3.2.5, G201). Most target="_blank" links come from
  content and apps, not the theme: rich text in pages and articles, section
  settings, review widgets. Each one gets Patrol's own convention, a
  visually hidden " (opens in a new tab)" span; a link named by aria-label
  gets the words in the label instead, because aria-label hides its content.

  Prices drawn from data-compare-price (WCAG 1.3.1). The theme paints the
  struck-through price as ::before { content: attr(data-compare-price) },
  so a screen reader heard "$181.75$104.95". nectar-palette.css silences
  the pseudo-element; this puts "Original price $181.75, sale price" in a
  hidden span just before the price. Alpine sets the attribute and the text
  after load, so both are kept in step with a MutationObserver.
*/
(() => {
  const NEW_TAB = ' (opens in a new tab)';

  const markNewTab = (a) => {
    if (a.dataset.a11yNewTab !== undefined) return;
    a.dataset.a11yNewTab = '';
    if (/new (tab|window)/i.test(a.getAttribute('aria-label') || a.textContent)) return;
    if (a.querySelector('.patrol-blank-target')) return;
    if (a.hasAttribute('aria-label')) {
      a.setAttribute('aria-label', a.getAttribute('aria-label') + NEW_TAB);
      return;
    }
    const span = document.createElement('span');
    span.className = 'patrol-sr-only patrol-blank-target';
    span.textContent = NEW_TAB;
    a.append(span);
  };

  const labelFor = (el) => {
    const prev = el.previousElementSibling;
    return prev && prev.hasAttribute('data-a11y-compare') ? prev : null;
  };

  const syncPrice = (el) => {
    const compare = (el.getAttribute('data-compare-price') || '').trim();
    const struck = compare && compare !== el.textContent.trim() &&
      getComputedStyle(el, '::before').content !== 'none';
    let label = labelFor(el);
    if (!struck) { if (label) label.remove(); return; }
    if (!label) {
      label = document.createElement('span');
      label.className = 'patrol-sr-only';
      label.setAttribute('data-a11y-compare', '');
      el.before(label);
    }
    const text = `Original price ${compare}, sale price`;
    if (label.textContent !== text) label.textContent = text;
  };

  let queued = false;
  const scan = () => {
    queued = false;
    document.querySelectorAll('a[target="_blank"]:not([data-a11y-new-tab])').forEach(markNewTab);
    document.querySelectorAll('[data-compare-price]').forEach(syncPrice);
    document.querySelectorAll('[data-a11y-compare]').forEach((label) => {
      const next = label.nextElementSibling;
      if (!next || !next.hasAttribute('data-compare-price')) label.remove();
    });
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(scan); } };

  const start = () => {
    scan();
    new MutationObserver((mutations) => {
      // Our own label edits must not re-trigger the scan forever.
      if (mutations.every((m) => m.target.nodeType === 1
        ? m.target.hasAttribute('data-a11y-compare')
        : m.target.parentElement?.hasAttribute('data-a11y-compare'))) return;
      queue();
    }).observe(document.body, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['data-compare-price', 'target'],
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
